import mongoose from "mongoose";

export interface Location {
  _id: mongoose.Schema.Types.ObjectId;
  /* This is the ITSM account ID.  NOT PS Portal customer ID. */
  accountId: string;
  relatedAccountIds?: string[];
  locationId?: string;
  locationName?: string;
  bpid?: string;
  opsi?: string; /* warning: in response, may be "opsi" or "OPSI" - prefer "opsi" */
  locationType: string[];
  address: {
    name1: string;
    name2: string;
    line1: string;
    line2: string;
    city: string;
    region: string;
    regionName: string;
    regionAbbreviation: string;
    postalCode: string;
    country: string;
    countryName: string;
    active: string;
  }
  shippingLabel1?: string;
  shippingLabel2?: string;
  deliveryType?: string;
}

export const LocationSchema = new mongoose.Schema<Location>({
  accountId: { type: String, index: true },
  relatedAccountIds: { type: [String], index: true },
  locationId: { type: String, index: true, unique: true },
  locationName: String,
  bpid: String,
  opsi: String,
  locationType: [String],
  address: {
    _id: false,
    name1: String,
    name2: String,
    line1: String,
    line2: String,
    city: String,
    region: String,
    regionName: String,
    regionAbbreviation: String,
    postalCode: String,
    country: String,
    countryName: String,
    active: String,
  },
  shippingLabel1: String,
  shippingLabel2: String,
  deliveryType: String,
});

export const searchProps: (keyof Location)[] = [
  "locationName",
  "address.line1" as keyof Location,
  "address.city" as keyof Location,
  "address.region" as keyof Location,
];

export const filterProps: (keyof Location)[] = [
  "address.country" as keyof Location,
];

export const locationUtils = {
  searchProps,
  filterProps,
};
